module.exports = __webpack_public_path__ + "static/img/1200x150.68db592.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1200x150.png
// module id = LFUT
// module chunks = 7